import { useState, useEffect, createContext, useContext } from "react";
import axios from "axios";
import { API } from "../App";

const CompressionContext = createContext({
  maxWidth: 1920,
  maxHeight: 1080,
  quality: 0.85,
  maxSizeKB: 500,
});

export function CompressionProvider({ children, token }) {
  const [settings, setSettings] = useState({
    maxWidth: 1920,
    maxHeight: 1080,
    quality: 0.85,
    maxSizeKB: 500,
  });

  useEffect(() => {
    if (!token) return;
    axios
      .get(`${API}/settings/compression`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setSettings({
          maxWidth: res.data.max_width,
          maxHeight: res.data.max_height,
          quality: res.data.quality,
          maxSizeKB: res.data.max_size_kb,
        });
      })
      .catch(() => {});
  }, [token]);  // API is a module-level constant

  return (
    <CompressionContext.Provider value={settings}>
      {children}
    </CompressionContext.Provider>
  );
}

export function useCompressionSettings() {
  return useContext(CompressionContext);
}
